/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-useless-constructor */
import SelectorEngine from '../../utils/dom/selector-engine';
import DuetDateComponent from '../DuetDateComponent';
import FormComponent from '../FormComponent';
import SelectComponent from '../SelectComponent';
import { QuestionTypes } from '../FormGenerator';
import InputField from '../InputField';
import _ from 'lodash';

class TournamentDetailsSearch extends FormComponent {
	constructor(element, config) {
		super(element, config);
		this.value = {
			tournamentCode: undefined,
			tournamentName: undefined,
			tournamentStartDate: undefined,
			tournamentEndDate: undefined,
			tournamentGrade: undefined,
			tournamentVenue: undefined,
			tournamentRefreeName: undefined
		};
	}
	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-tournament-details-search">
				<div class="lta-tournament-details-search-title u-hidden">${titleMarkup}</div>
                <div class="lta-tournament-details-search--details-form u-mb-2">
				<p class="lta-text-input__label u-mb-3">Please enter the tournament details manually</p>
				<div class="lta-tournament-details-search--tournament-code u-mb-3"></div>
				<div class="lta-tournament-details-search--tournament-name u-mb-3"></div>
				<div class="lta-tournament-details-search--details-start-date u-mb-3"></div>
				<div class="lta-tournament-details-search--details-end-date u-mb-3"></div>
				<div class="lta-tournament-details-search--grade u-mb-3"></div>
				<div class="lta-tournament-details-search--venue u-mb-3"></div>
				<div class="lta-tournament-details-search--refree-name u-mb-3"></div>
                </div>
            </div>
        `;
	}
	afterRender() {
		this.tournamentDetailsSearchElement = SelectorEngine.findOne('.lta-tournament-details-search', this.containerEl);
		this.tournamentDetailsSearchForm = SelectorEngine.findOne(
			'.lta-tournament-details-search--details-form',
			this.tournamentDetailsSearchElement
		);
		this.tournamentCode = SelectorEngine.findOne(
			'.lta-tournament-details-search--tournament-code',
			this.tournamentDetailsSearchForm
		);
		this.tournamentName = SelectorEngine.findOne(
			'.lta-tournament-details-search--tournament-name',
			this.tournamentDetailsSearchForm
		);
		this.tournamentStartDate = SelectorEngine.findOne(
			'.lta-tournament-details-search--details-start-date',
			this.tournamentDetailsSearchForm
		);
		this.tournamentEndDate = SelectorEngine.findOne(
			'.lta-tournament-details-search--details-end-date',
			this.tournamentDetailsSearchForm
		);
		this.tournamentGrade = SelectorEngine.findOne(
			'.lta-tournament-details-search--grade',
			this.tournamentDetailsSearchForm
		);
		this.tournamentVenue = SelectorEngine.findOne(
			'.lta-tournament-details-search--venue',
			this.tournamentDetailsSearchForm
		);
		this.tournamentRefreeName = SelectorEngine.findOne(
			'.lta-tournament-details-search--refree-name',
			this.tournamentDetailsSearchForm
		);
		this.detailsObjects = [];
		this.detailsObjects = [
			{
				inputElementData: this.tournamentCode,
				elementDataKey: 'tournamentCode',
				type: QuestionTypes.ITTProviderSearch
			},
			{
				inputElementData: this.tournamentName,
				elementDataKey: 'tournamentName',
				type: QuestionTypes.ITTProviderSearch
			},
			{
				inputElementData: this.tournamentVenue,
				elementDataKey: 'tournamentVenue',
				type: QuestionTypes.ITTProviderSearch
			},
			{
				inputElementData: this.tournamentRefreeName,
				elementDataKey: 'tournamentRefreeName',
				type: QuestionTypes.ITTProviderSearch
			},
			{
				duetDateElementData: this.tournamentStartDate,
				elementDataKey: 'tournamentStartDate',
				type: QuestionTypes.DuetDateComponent
			},
			{
				duetDateElementData: this.tournamentEndDate,
				elementDataKey: 'tournamentEndDate',
				type: QuestionTypes.DuetDateComponent
			},
			{
				selectElementData: this.tournamentGrade,
				elementDataKey: 'tournamentGrade',
				type: QuestionTypes.Select,
				options: [
					{
						id: '1',
						label: '1'
					},
					{
						id: '2',
						label: '2'
					},
					{
						id: '3',
						label: '3'
					},
					{
						id: '4',
						label: '4'
					},
					{
						id: '5',
						label: '5'
					},
					{
						id: '6',
						label: '6'
					},
					{
						id: '7',
						label: '7'
					},
					{
						id: '8',
						label: 'ATP'
					},
					{
						id: '9',
						label: 'TE'
					},
					{
						id: '10',
						label: 'ITF'
					},
					{
						id: '11',
						label: 'WTA'
					},
					{
						id: '12',
						label: 'Wheelchair'
					},
					{
						id: '13',
						label: 'Ungraded Recreational'
					}
				]
			}
		];
		this.initInputObject();
	}
	initInputObject() {
		for (const detailsObject of this.detailsObjects) {
			switch (detailsObject.type) {
				case QuestionTypes.DuetDateComponent:
					const dateFieldObject = new DuetDateComponent(detailsObject.duetDateElementData, {
						data: this.data[detailsObject.elementDataKey]
					});
					detailsObject.duetDateElement = dateFieldObject;
					dateFieldObject.onChange((dataObject) => {
						detailsObject.duetDateElement.validate();
						detailsObject.value = dataObject.value;
						this.value[detailsObject.elementDataKey] = detailsObject?.value;
						this.validateDates(detailsObject.elementDataKey === 'tournamentStartDate');
					});
					if(detailsObject.elementDataKey === 'tournamentStartDate') {
						this.tournamentStartDateInstance = dateFieldObject;
					}
					if(detailsObject.elementDataKey === 'tournamentEndDate') {
						this.tournamentEndDateInstance = dateFieldObject;
					}
					break;
				case QuestionTypes.Select:
					const selectFieldObject = new SelectComponent(detailsObject.selectElementData, {
						data: this.data[detailsObject.elementDataKey]
					});
					detailsObject.selectElement = selectFieldObject;
					selectFieldObject.onChange((dataObject) => {
						detailsObject.selectElement.validate();
						detailsObject.value = dataObject.value;
						this.value[detailsObject.elementDataKey] = detailsObject?.value;
					});
					break;
				case QuestionTypes.ITTProviderSearch:
				default:
					const inputFieldObject = new InputField(detailsObject.inputElementData, {
						data: this.data[detailsObject.elementDataKey]
					});
					detailsObject.inputElement = inputFieldObject;
					inputFieldObject.onChange((dataObject) => {
						detailsObject.inputElement.validate();
						detailsObject.value = dataObject.value;
						this.value[detailsObject.elementDataKey] = detailsObject?.value;
					});
					break;
			}
		}
	}
	preparedetailsObject(tournamentObject) {
		const modifyObject = {
			tournamentCode: tournamentObject.tournamentCode,
			tournamentName: tournamentObject.tournamentName,
			tournamentStartDate: tournamentObject.tournamentStartDate,
			tournamentEndDate: tournamentObject.tournamentEndDate,
			tournamentGrade: tournamentObject.tournamentGrade,
			tournamentVenue: tournamentObject.tournamentVenue,
			tournamentRefreeName: tournamentObject.tournamentRefreeName
		};
		return modifyObject;
	}
	validate() {
		for (const inputElementObject of this.detailsObjects) {
			if (inputElementObject.inputElement) {
				inputElementObject.inputElement.validate();
			}
		}
		for (const dateElementObject of this.detailsObjects) {
			if (dateElementObject.duetDateElement) {
				dateElementObject.duetDateElement.validate();
			}
		}
		for (const selectElementsObject of this.detailsObjects) {
			if (selectElementsObject.selectElement) {
				selectElementsObject.selectElement.validate();
			}
		}
		this.isInValid = Object.keys(this.value).some((key) => !this.value[key]);
		if (!this.isInValid) {
			localStorage.removeItem('TournamentStartDate');
			localStorage.removeItem('TournamentEndDate');
			let finalObject = this.preparedetailsObject(this.value);
			this.value = {
				...this.value,
				...finalObject
			};
			return !this.isInValid;
		} else {
			return this.isInValid;
		}
	}

	validateDates(isStartDate) {
		const startDate = this.value.tournamentStartDate;
		const endDate = this.value.tournamentEndDate;
		if (startDate && endDate) {
			if (startDate > endDate) {
				console.log('startDate is greater than endDate');
				if(isStartDate) {
					this.tournamentStartDateInstance.addInvalidClass('Start date cannot be greater than end date');
				} else {
					this.tournamentEndDateInstance.addInvalidClass('End date cannot be less than start date');
				}
			} else {
				this.tournamentStartDateInstance.removeInvalidClass();
				this.tournamentEndDateInstance.removeInvalidClass();
			}
		}
	}
}
export default TournamentDetailsSearch;
